<template>
	<div class="app-main gysRegister-page">
		<el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="10">
			<el-col :span="24">
				<div class="register-box" v-loading="loading">
					<div class="info-left">
						<el-card class="box-card" shadow="hover">
							<el-steps direction="vertical" :active="steps" :space="42">
								<el-step @click.native="stepsNumSet(0)" title="企业信息"></el-step>
								<el-step @click.native="stepsNumSet(1)" title="业务信息"></el-step>
								<el-step @click.native="stepsNumSet(2)" title="供货类别"></el-step>
								<el-step @click.native="stepsNumSet(3)" title="联系人信息"></el-step>
								<el-step @click.native="stepsNumSet(4)" title="地址信息"></el-step>
								<el-step @click.native="stepsNumSet(5)" title="银行信息"></el-step>
								<el-step @click.native="stepsNumSet(6)" title="开票信息"></el-step>
								<el-step @click.native="stepsNumSet(7)" title="财务信息"></el-step>
								<el-step @click.native="stepsNumSet(8)" title="公司附件"></el-step>
								<el-step @click.native="stepsNumSet(9)" title="查看预览"></el-step>
							</el-steps>
						</el-card>
					</div>
					<div class="info-right">
						<el-card class="box-card" shadow="hover">
							<div class="info-wrap">
								<RegisterInfo v-if="steps==0 && basicId" ref="RegisterInfoRef" :basicId="basicId" :otherInfo="otherInfo"></RegisterInfo>
								<YwInfo v-if="steps==1 && basicId" ref="YwInfoRef" :basicId="basicId" :otherInfo="otherInfo"></YwInfo>
								<JyClassify v-if="steps==2 && basicId" :basicId="basicId" :otherInfo="otherInfo"></JyClassify>
								<LxrInfo v-if="steps==3 && basicId" :basicId="basicId" :otherInfo="otherInfo"></LxrInfo>
								<Address v-if="steps==4 && basicId" :basicId="basicId" :otherInfo="otherInfo"></Address>
								<BankInfo v-if="steps==5 && basicId" :basicId="basicId" :otherInfo="otherInfo"></BankInfo>
								<InvoiceInfo v-if="steps==6 && basicId" ref="InvoiceInfoRef" :basicId="basicId" :otherInfo="otherInfo"></InvoiceInfo>
								<CwInfo v-if="steps==7 && basicId" :basicId="basicId" :otherInfo="otherInfo"></CwInfo>
								<FileInfo v-if="steps==8 && basicId" :basicId="basicId" :otherInfo="otherInfo"></FileInfo>
								<PreView v-if="steps==9 && basicId" :basicId="basicId" :otherInfo="otherInfo"></PreView>
							</div>
						</el-card>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import { supplierInfoById } from '@/api/gys/supplierInfo.js'
	import RegisterInfo from '@/components/Gys/RegisterInfo.vue'
	import YwInfo from '@/components/Gys/YwInfo.vue'
	import JyClassify from '@/components/Gys/JyClassify.vue'
	import LxrInfo from '@/components/Gys/LxrInfo.vue'
	import Address from '@/components/Gys/Address.vue'
	import BankInfo from '@/components/Gys/BankInfo.vue'
	import InvoiceInfo from '@/components/Gys/InvoiceInfo.vue'
	import CwInfo from '@/components/Gys/CwInfo.vue'
	import FileInfo from '@/components/Gys/FileInfo.vue'
	import PreView from '@/components/Gys/PreView.vue'
	export default {
		name: "GysRegister",
		components: {
			RegisterInfo,
			YwInfo,
			JyClassify,
			LxrInfo,
			Address,
			BankInfo,
			InvoiceInfo,
			CwInfo,
			FileInfo,
      		PreView
		},
		data() {
			return {
				loading:false,
				steps: 0,
				basicId: null,
				otherInfo:{
					lastPass:false,
				},

			};
		},
		mounted() {
			console.log(this.$route.params)
			this.bus.$on('stepsFun', res => {
				this.steps = res;
			});
		},
		beforeDestroy() {
			this.bus.$off('stepsFun');
		},
		created() {
			if(this.$route.params.editId){
				this.basicId = Number(this.$route.params.editId);
				this.steps = 0;
				this.otherInfo.lastPass = true;
			}else{
				this.getGysId()
			}
		},
		methods: {
			async getGysId(){
				this.loading = true;
				const { data: res } = await supplierInfoById({ id: null })
				this.basicId = res.data.id;
				this.steps = 0;
				this.loading = false;
				// console.log(res.data.id)
			},
			stepsNumSet(index){
				if(this.steps == index || !this.basicId){
					return
				}
				if(this.steps == 0){	// 企业信息
					this.$refs.RegisterInfoRef.submitForm(index)
					return
				}
				if(this.steps == 1){	// 业务信息
					this.$refs.YwInfoRef.submitForm(index)
					return
				}
				if(this.steps == 6){	// 开票信息
					this.$refs.InvoiceInfoRef.submitForm(index)
				}
				this.steps = index;
				// if(index>0 && this.basicId){
				// 	this.steps = index;
				// }else{
				// 	this.steps = index;
				// }
			},
			// 跳转回调
			stepcallback(obj){

			},
			basicIdFun: function(data) {
				if (data) {
					this.basicId = data;
				}
      		}
		}
	};
</script>
<style lang="scss">
	.gysRegister-page{
		.info-wrap{
			max-height: calc(100vh - 150px);
			margin-bottom: 20px;
			overflow-y: auto;
		}
		.register-box{
			display: flex;
			justify-content: space-between;
			.info-left{
				width: 160px;
				.el-step__title{
					font-size: 14px;
				}
				.el-step{
					.is-process,.is-finish{
						color: #4e6ef2!important;
						.el-step__icon.is-text{
							border-color: #4e6ef2!important;
						}
					}
				}
			}
			.info-right{
				width: calc(100% - 170px);
			}
		}
		//
	}

</style>
